import React from 'react';
import { useParams } from 'react-router-dom';
import { useApi } from '../classes/appApi';
import MainLayout from '../components/MainLayout';
import { ServiceOrderModel } from '../defs/defs';
import ContinuumFormList from '../shared/components/ContinuumFormList';
import ControlledDocumentList from '../shared/components/ControlledDocumentList';
import EqxCard from '../shared/components/EqxCard/EqxCard';
import EqxRequestHandler from '../shared/components/EqxRequestHandler/EqxRequestHandler';
import EqxTaskStatusBadge from '../shared/components/EqxTaskStatusBadge';
import useApiEndpoint from '../shared/hooks/ApiEndpoint';
import { formatDate } from '../shared/utils/formatDate';

const PageServiceOrderDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const api = useApi();
    const { response: order, loading, error } = useApiEndpoint<ServiceOrderModel>(api, api.endpoints.serviceOrder(id!));

    return (
        <MainLayout pageTitle={order ? order.title : "Service Order Detail"} relatedLinks={[{ url: "/service-orders", text: "Service Orders" }]}>
            <EqxRequestHandler state={{ loading, error }} isEmpty={!order} empty={<div className="p-5 text-center text-muted">Service order not found</div>}>
                {order && (
                    <>
                        <EqxCard title={order.displayID} isSection={true} headerRight={<EqxTaskStatusBadge status={order.taskStatus} />}>
                            <dl className="dl-horizontal dl-horizontal-2-col">
                                <dt>ID</dt>
                                <dd>{order.id}</dd>
                                <dt>Start Date</dt>
                                <dd>{formatDate(order.startDate)}</dd>
                                <dt>Operation</dt>
                                <dd>{order.operation?.name ?? <span className="text-muted">Unknown</span>}</dd>
                                <dt>Operating Unit</dt>
                                <dd>{order.operatingUnit?.name ?? <span className="text-muted">Unknown</span>}</dd>
                            </dl>
                        </EqxCard>
                        <EqxCard title="Operation/Process Documents" isSection={true} noPadding={true}>
                            {order.controlledDocuments && order.controlledDocuments.length > 0 ? (
                                <ControlledDocumentList documents={order.controlledDocuments} isChild={true} />
                            ) : (
                                <div className="p-4 text-center text-muted">No documents</div>
                            )}
                        </EqxCard>
                        <EqxCard title="Continuum Forms" isSection={true} noPadding={true}>
                            {order.continuumForms && order.continuumForms.length > 0 ? (
                                <ContinuumFormList
                                    forms={order.continuumForms}
                                    isChild={true}
                                    taskID={order.id.toString()}
                                    useModal={true}
                                />
                            ) : (
                                <div className="p-4 text-center text-muted">No forms</div>
                            )}
                        </EqxCard>
                    </>
                )}
            </EqxRequestHandler>
        </MainLayout>
    );
};

export default PageServiceOrderDetail; 